@if (mode === 'simple') {
	<footer class="footer-simple mt-auto" [ngClass]="classes">
		<div class="container-fluid">
			<div class="row">
				<div class="col-md-12 small">SilGov Copyright &copy; {{ fullYear }} - v{{ version }}</div>
				<div class="col-md-12 small">
					<a [href]="'./politics'">Política de Privacidade</a>
					&middot;
					<a [href]="'./terms'">Termos e Condições</a>
				</div>
				@if (googlePolicyUseTerms) {
					<div class="col-md-12 small">
						@if (!infoReCaptcha) {
							<div class="pt-2 pb-2">
								Esta página é protegida pelo Google reCAPTCHA para garantir que você não é um robô.
								<small class="text-info cursor-pointer-hover" (click)="infoReCaptcha = true">Saíba mais</small>
							</div>
						}
						@if (infoReCaptcha) {
							<div class="animated fadeIn">
								As informações recolhidas pelo Google reCAPTCHA estão sujeitas à
								<a href="https://policies.google.com/privacy">Política de Privacidade</a>
								e
								<a href="https://policies.google.com/terms">Termos de Uso</a>
								, e são usadas para oferecer, manter e melhorar o serviço reCAPTCHA e por questões de segurança (não são usadas para exibir
								anúncios personalizados pelo Google).
							</div>
						}
					</div>
				}
			</div>
		</div>
	</footer>
} @else {
	<footer class="footer">
		<div class="container mb-4">
			<div class="row">
				<div class="col-lg-4">
					<h1 class="footer-brand">SilGov</h1>
					<p class="fw-light">
						Plataforma para Gestão
						<br />
						administrativa de Licitações.
					</p>
					@if (false) {
						<p class="mb-3 fw-bold">CNPJ 42.715.505/0001-82</p>
					}
				</div>
				<div class="col-lg-8">
					<div class="row">
						<div class="col-lg-4 col-md-6 mb-5 mb-lg-0">
							<h5 class="mb-4">Legal</h5>
							<ul class="list-unstyled mb-0">
								<li class="mb-2"><a [href]="'./terms'">Termos de uso</a></li>
								<li class="mb-2"><a [href]="'./politics'">Políticas de privacidade</a></li>
							</ul>
						</div>
						<div class="col-lg-4 col-md-6 mb-5 mb-lg-0">
							<h5 class="mb-4">Responsável técnico</h5>
							<ul class="list-unstyled mb-0">
								<li class="mb-2">
									<a href="https://wa.me/558581647550" target="_blank">
										<fa-icon [icon]="['fab', 'whatsapp']"></fa-icon>
										+55 (85) 9 81647550
									</a>
								</li>
							</ul>
						</div>
						<div class="col-lg-4 col-md-6">
							<h5 class="mb-4">Redes social</h5>
							<div class="icon-list-social mb-5">
								<a class="icon-list-social-link" href="https://www.instagram.com/silgov.br" target="_blank">
									<fa-icon [icon]="['fab', 'instagram']"></fa-icon>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="footer__bar">
			<div class="container d-flex justify-content-between align-items-center">
				<p class="small mb-0">SilGov Copyright &copy; {{ fullYear }}</p>
				<p class="small mb-0">
					Fale conosco &middot;
					<a href="mailto:contato@silgov.com.br">contato&#64;silgov.com.br</a>
				</p>
			</div>
		</div>
	</footer>
}
